'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var ScenarioController = function ScenarioController($scope, $rootScope, $compile, scenarioService, scenarioConstants, Scenario, userActionService, overridesSaveService, overridesUtilsService, configurationService, $q, reoptimizationSaveService, reoptPreviewDataUtilsService, saveButtonUtilsService, $log) {
  var errorTemplate = _.template(require('../templates/error-message.html'));
  var flightManagementReoptGrids = ['flight-summary', 'inventory-management', 'overbooking-management'];
  $scope.newScenarioDisplayName = '';
  $scope.scenarios = [];
  $scope.actionTypes = {
    CREATE: 'create',
    SAVE: 'save',
    UPDATE: 'update'
  };
  $scope.$watch('actionType', function () {
    if ($scope.actionType !== $scope.actionTypes.CREATE) {
      $scope.newScenarioDisplayName = '';
    }
  });
  $scope.resetForm = function () {
    $scope.actionType = $scope.actionTypes.SAVE;
    $scope.newScenarioDisplayName = undefined;
    $scope.scenario = undefined;
    $scope.saveScenarioForm.$pristine = true;
    $scope.saveScenarioForm.$valid = true;
  };
  $scope.actionType = $scope.actionTypes.SAVE;
  $scope.reoptStatuses = scenarioService.getReoptStatuses();
  $scope.loadScenarioList = function () {
    $scope.scenarios = scenarioService.getScenarioList();
  };
  $scope.isScenarioLimitReached = function () {
    return $scope.scenarios.length >= configurationService.getNumberOfAllowedScenarios();
  };
  $scope.isPreviewingReoptData = function () {
    var retval = $scope.reoptSaveData && $scope.reoptSaveData.previewMode;
    if (retval) {
      if ($scope.reoptPreviewData && $scope.reoptPreviewData.ndReopt) {
        if (['market-demand-analysis', 'market-product-group-analysis', 'service-demand-analysis'].indexOf($scope.overridesGridId) >= 0) {
          retval = false;
        }
      }
    }
    return retval;
  };
  $scope.isSavingToExistingScenarioDisabled = function () {
    return $scope.isScenariosEmpty() || $scope.isPreviewingReoptData() || $scope.disabledExistingScenario;
  };
  $scope.isSavingToNewScenarioDisabled = function () {
    return $scope.isScenarioLimitReached() || $scope.isPreviewingReoptData() || $scope.disabledNewScenario;
  };
  $scope.isScenariosEmpty = function () {
    return $scope.scenarios.length === 0;
  };
  $scope.getScenarioName = function () {
    return $scope.scenario && $scope.scenario.scenarioName;
  };
  $scope.removeReoptPreview = function () {
    delete $scope.reoptPreviewData.mdReopt;
    delete $scope.reoptPreviewData.ndReopt;
  };
  $scope.saveReoptimizationCallback = function () {
    $scope.removeReoptPreview();
  };
  $scope.saveScenario = function () {
    /*
     In case we have reoptPreview data structure, we want to productionize preview
     documents before saving additional overrides and remove the preview structure
     */
    if ($scope.reoptSaveData) {
      $scope.saveReoptimizationResults().then(function () {
        $scope.saveOverridesToScenario().then(function () {
          //Must be run after Saving Overrides.
          if ($scope.overridesGridId.indexOf('cabin') === -1) {
            $rootScope.$broadcast('grid:setDeferredClear:cabin-flight-analysis');
          }
          $scope.saveReoptimizationCallback();
        });
      });
    } else if ($scope.actionType === $scope.actionTypes.CREATE) {
      var displayName = $scope.newScenarioDisplayName;
      var userId = configurationService.getUserId();
      var scenarioName = userId + '_' + displayName;
      $scope.createScenario(userId, displayName).then(function () {
        return $scope.saveOverridesToScenario(scenarioName);
      });
    } else {
      $scope.saveOverridesToScenario($scope.getScenarioName());
    }
  };
  $scope.$on('save-modal:getGridInfo', function (event, data, gridId) {
    $scope.saveOverrides(data, gridId, scenarioService.getSelectedScenarioName(), false);
  });
  function scenarioNotSelected(scenarioName) {
    return scenarioName !== $scope.getSelectedScenarioName() && !scenarioService.isPreviewRequest(scenarioName);
  }
  $scope.selectScenario = function (scenarioName) {
    if (scenarioNotSelected(scenarioName)) {
      var targetScenario = _.find(scenarioService.getScenarioList(), {
        'scenarioName': scenarioName
      });
      scenarioService.selectScenario(targetScenario);
    }
  };
  $scope.saveOverridesToScenario = function (scenarioName) {
    var switchingToScenario = scenarioNotSelected(scenarioName);
    var promise;
    if (reoptPreviewDataUtilsService.isPreview($scope.reoptPreviewData)) {
      promise = $q.all(isFlightManagement() ? saveOverridesFlightManagement() : saveOverridesFlightAnalysis(scenarioName, switchingToScenario));
    } else {
      promise = $scope.saveOverrides($scope.overridesData, $scope.overridesGridId, scenarioName, switchingToScenario);
    }
    return promise.then(function () {
      $scope.selectScenario(scenarioName);
    });
  };
  function isFlightManagement() {
    return _.filter($scope.reoptPreviewData.gridDetails, function (jqxGrid, gridId) {
      return flightManagementReoptGrids.indexOf(gridId) >= 0;
    }).length > 0;
  }
  function saveOverridesFlightManagement() {
    var gridsToSave = _.concat(flightManagementReoptGrids, ['market-product-group-analysis', 'service-demand-analysis']);
    return gridsToSave.reduce(function (accumulatorPromise, gridId) {
      return accumulatorPromise.then(function () {
        var jqxSettings = $scope.reoptPreviewData.gridDetails[gridId];
        return $scope.saveOverrides(saveButtonUtilsService.getEditedRows(jqxSettings), gridId, scenarioService.PUBLISHED);
      });
    }, $q.when([])).then(function () {
      $rootScope.$broadcast('re-opt:save-finished');
    });
  }
  function saveOverridesFlightAnalysis(scenarioName, switchingToScenario) {
    var visibleFlightGrid = $scope.reoptPreviewData.visibleFlightGrid;
    var visibleMarketGrid = $scope.reoptPreviewData.visibleMarketGrid;
    var jqxFlightGrid = $scope.reoptPreviewData.gridDetails[visibleFlightGrid];
    var jqxMarketGrid = $scope.reoptPreviewData.gridDetails[visibleMarketGrid];
    var saveOverrides = [$scope.saveOverrides(saveButtonUtilsService.getEditedRows(jqxFlightGrid), visibleFlightGrid, scenarioName, switchingToScenario)];
    if (reoptPreviewDataUtilsService.isMdReoptPreview($scope.reoptPreviewData)) {
      saveOverrides.push($scope.saveOverrides(saveButtonUtilsService.getEditedRows(jqxMarketGrid), visibleMarketGrid, scenarioName, switchingToScenario));
    }
    return saveOverrides;
  }
  $scope.saveReoptimizationResults = function () {
    if ($scope.reoptSaveData.mdReoptKeyRow) {
      return reoptimizationSaveService.mdReoptPublishDocuments($scope.reoptSaveData.mdReoptKeyRow);
    } else if ($scope.reoptSaveData.ndReoptKeyRow) {
      return reoptimizationSaveService.ndReoptPublishDocuments($scope.reoptSaveData.ndReoptKeyRow, 'N');
    } else {
      return $q.when('Request is not made from flight cabin analysis grid or no row has been selected in cabin-flight-analysis grid');
    }
  };
  function saveUserActions(overridesData) {
    var flightIds = _.compact(_.map(overridesData, 'flightId'));
    if (flightIds.length > 0) {
      userActionService.saveUserAction('FLIGHT', flightIds, 'SAVE');
    }
  }
  $scope.saveOverrides = function (overridesData, gridId, scenarioName, switchingToScenario) {
    if (overridesData && overridesData.length) {
      saveUserActions(overridesData);
      return overridesSaveService.saveOverrides(overridesData, gridId, scenarioName).then(function (resultList) {
        var cleanUpData = {
          data: overridesData,
          gridId: gridId
        };
        $rootScope.$broadcast('overrides:saved', cleanUpData);
        return cleanUpOverrides(cleanUpData, resultList, scenarioName, switchingToScenario);
      }, function () {
        var scenarioMessage = scenarioName ? ' to ' + scenarioName : '';
        $log.error('ScenarioController: saveOverrides - Could not save' + scenarioMessage);
        toastr.error('Could not save user adjustments' + scenarioMessage);
        return $q.reject('User adjustments saving error');
      });
    } else {
      /**
       * Resolve this instead rejection to not break the serialize promises.
       */
      return $q.resolve('Overrides data is empty');
    }
  };
  function cleanUpOverrides(saveData, saveStatusList, scenarioName, switchingToScenario) {
    var result = overridesUtilsService.cleanUpAfterSave(saveData.data, saveStatusList, saveData.gridId, scenarioName, switchingToScenario);
    $rootScope.$broadcast('scenarios:saved', saveData.gridId);
    $rootScope.$broadcast('grid:data-pristine');
    var scenarioMessage = scenarioName ? ' to ' + scenarioName : '';
    if (result > 0) {
      $log.warn('ScenarioController: cleanUpOverrides - Overrides have been saved partially' + scenarioMessage);
      toastr.warning('Overrides have been saved partially' + scenarioMessage);
      return $q.resolve();
    } else if (result === 0) {
      if (!scenarioService.isPreviewRequest(scenarioName)) {
        $rootScope.$broadcast('clearChangedValue');
        toastr.success('Saved Successfully' + scenarioMessage);
      }
      return $q.resolve();
    } else {
      $log.error('ScenarioController: cleanUpOverrides - Could not save' + scenarioMessage);
      toastr.error('Could not save' + scenarioMessage);
      return $q.reject('Scenario saving error');
    }
  }
  $scope.createScenario = function (userId, displayName) {
    var newScenario = new Scenario(displayName, userId, $scope.reoptStatuses.notOptimized);
    return scenarioService.createScenario(newScenario).then($scope.createScenarioSuccess, $scope.createScenarioFailure);
  };
  function showErrorMessage(response, operation) {
    if (operation === 'creating') {
      response.data.fieldErrors = [{
        field: 'Contains invalid characters',
        message: '(Accepts only alphabetical characters)'
      }];
    }
    var message = errorTemplate({
      'response': response,
      'operation': operation
    });
    $log.error('ScenarioController: showErrorMessage - ' + message);
    toastr.error(message);
  }
  $scope.createScenarioFailure = function (response) {
    showErrorMessage(response, 'creating');
  };
  $scope.createScenarioSuccess = function (response) {
    return scenarioService.updateScenarioList().then(function () {
      var scenario = new Scenario();
      scenario.fromResponse(response);
      $scope.newScenarioDisplayName = '';
      $scope.actionType = $scope.actionTypes.SAVE;
      if (!scenarioService.isPreviewRequest(scenario)) {
        $scope.scenarios.push(scenario);
        $scope.scenario = scenario;
        toastr.success('Successfully created scenario.');
      }
    });
  };
  $scope.isInvalidForm = function () {
    return $scope.saveScenarioForm.$invalid;
  };
  $scope.isValidScenarioName = function (value) {
    if (value === scenarioService.PUBLISHED) {
      return false;
    } else {
      var trimmedValue = _.trim(value);
      return !_.some($scope.scenarios, {
        displayName: trimmedValue
      });
    }
  };
  $scope.isNotNDAndMDPreviewRequest = function (value) {
    return value.toLowerCase() !== scenarioConstants.ND_PREVIEW_REQUEST.toLowerCase() && value.toLowerCase() !== scenarioConstants.MD_PREVIEW_REQUEST.toLowerCase();
  };
  $scope.resetScenarioNameValidity = function () {
    if (_.isUndefined($scope.saveScenarioForm)) {
      return;
    }
    $scope.saveScenarioForm.scenario.$setValidity('scenarioNameAlreadyUsed', true);
    $scope.scenario = undefined;
  };
  $scope.$watch('actionType', function (actionType) {
    if (actionType !== $scope.actionTypes.CREATE) {
      $scope.resetScenarioNameValidity();
    }
  });
  $scope.isValidationFailed = function (validationName) {
    return $scope.saveScenarioForm.scenario.$dirty && $scope.saveScenarioForm.scenario.$error[validationName];
  };
  $scope.getSelectedScenarioName = function () {
    var selectedScenario = scenarioService.getSelectedScenario();
    return selectedScenario ? selectedScenario.scenarioName : undefined;
  };
  $scope.loadScenarioList();
};
ScenarioController.$inject = ['$scope', '$rootScope', '$compile', 'ScenarioService', 'ScenarioConstants', 'ScenarioFactory', 'UserActionService', 'OverridesSaveService', 'OverridesUtilsService', 'ConfigurationService', '$q', 'ReoptimizationSaveService', 'ReoptPreviewDataUtilsService', 'SaveButtonUtilsService', '$log'];
module.exports = ScenarioController;